import request from '@/utile/request'


/**
 * 发送手机验证码
 * */
export function mobileCode(params) {
    return request({
        url: '/v1/mobile/form/mobile_code',
        method: 'get',
        params
    })
}


/**
 * 媒体云账号登录
 * */
export function mobileLogin(data) {
    return request({
        url: '/v1/mobile/form/mobile_login',
        method: 'post',
        data
    })
}


/**
 * 手机验证码校验
 * */
export function mobileCheck(data) {
    return request({
        url: '/v1/mobile/form/mobile_check',
        method: 'post',
        data
    })
}


/**
 * 表单配置详情
 * */
export function formSetting(form_id) {
    return request({
        url: '/v1/mobile/form/get_setting',
        method: 'get',
        params: {
            form_id
        }
    })
}


/**
 * 表单详情
 * */
export function formDetail(params) {
    return request({
        url: '/v1/mobile/form/detail',
        method: 'get',
        params
    })
}


/**
 * 提交表单
 * */
export function formSubmit(data) {
    return request({
        url: '/v1/mobile/form/submit',
        method: 'post',
        data
    })
}


/**
 * 获取得分接口
 * */
export function getScore(submit_id) {
    return request({
        url: '/v1/mobile/form/get_score',
        method: 'get',
        params: {
            submit_id
        }
    })
}


/**
 * 获取个人排行榜
 * */
export function getRanking(params) {
    return request({
        url: '/v1/mobile/form/get_ranking',
        method: 'get',
        params
    })
}


/**
 * 获取单位排行榜
 * */
export function getCompanyranking(params) {
    return request({
        url: '/v1/mobile/form/get_companyranking',
        method: 'get',
        params
    })
}


/**
 * 获取答案解析
 * */
export function getAnalysis(id) {
    return request({
        url: '/v1/mobile/form/get_analysis',
        method: 'get',
        params: {
            submit_id: id
        }
    })
}


/**
 * 缓存用户答案接口
 * */
export function cacheAnswers(data) {
    return request({
        url: '/v1/mobile/form/cache_answers',
        method: 'post',
        data
    })
}


/**
 * 获取微信分享参数
 **/
export function wx_share(data) {
    return request({
        url: '/v1/mobile/form/wx_share',
        method: 'post',
        data
    })
}

// 上传文件的接口
export function uploadFileApi(formData) {
    return request({
        url: '/v1/mobile/form/upload',
        method: 'post',
        data: formData
    })
}


/**
 * 获取图形验证码接口
 * */
export function getCaptcha() {
    return request({
        url: '/v1/mobile/form/get_captcha',
        method: 'get'
    })
}


/**
 * 图形验证码校验接口
 * */
export function checkCaptcha(data) {
    return request({
        url: '/v1/mobile/form/check_captcha',
        method: 'post',
        data
    })
}

/**
 * 获取系统配置信息
 * */
export function getSystemSetting(params) {
    return request({
        url: '/v1/mobile/form/system_setting',
        method: 'get',
        params
    })
}
/**
 * 媒体云jssdk登录
 * */
export function cmsLogin(data) {
    return request({
        url: '/v1/mobile/form/cmstop_login',
        method: 'post',
        data
    })
}

/**
 * 新登录码登录验证
 * */
export function codeLogin(data) {
    return request({
        url: '/v1/mobile/form/check_authcode',
        method: 'post',
        data
    })
}




/**
 * 评议人员详情
 * */
export function getReviewRaterDetail(params) {
    return request({
        url: '/v1/mobile/form/rater_detail',
        method: 'get',
        params
    })
}

/**
 * 微信获取openid
 * */
export function getWechatOpenid(data) {
    return request({
        url: '/v1/mobile/form/mobile_openid',
        method: 'post',
        data
    })
}
